import { createFileRoute } from "@tanstack/react-router";
import CloudSyncedApp from "@/components/CloudSyncedApp";

export const Route = createFileRoute("/_authenticated/app")({
  component: CloudSyncedApp,
});
